/**
 * @author Kelnik
 *
 * YandexMapPopup - Карта в попапе
 */

import tmplNavigation from './templates/tmplNavPopup.twig';
import {Utils} from 'common/scripts/utils';
import YandexMap from 'components/yandex-map';

class YandexMapPopup {
    constructor(options) {
        this.container = options.container;
        this.target = options.target;
        this.activeClass = 'is-active';

        this.ymaps = window.ymaps;
    }

    init() {
        if (!this.container || !this.ymaps) {
            return;
        }

        this._initElements();
        this._initMap();
    }

    _initElements() {
        this.mapEl = this.container.querySelector('.j-popup-map');
        this.popupHeader = this.container.parentNode.querySelector('.j-popup__header');
    }

    _initMap() {
        if (!this.target.dataset.mapJson && !this.target.dataset.mapAjax) {
            return;
        }

        this.ymaps.ready(() => {
            this.map = new YandexMap(this.ymaps);

            this.map.init({
                wrapper                : this.mapEl,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true,
                json                   : this.target.dataset.mapJson || false,
                ajax                   : this.target.dataset.mapAjax || false,
                afterShow              : this._afterShowMap.bind(this)
            });
        });
    }

    _afterShowMap() {
        const markers = this.map.getMarkers();
        const markersWidthText = markers.filter((marker) => {
            return marker.typeText;
        });
        const types = Array.from(markersWidthText).map((marker, key) => {
            return {
                slug  : marker.type,
                text  : marker.typeText,
                active: key === 0
            };
        });

        this._insertHeaderNavigation(types);
        this._bindEventHeaderNavigation();
    }

    _insertHeaderNavigation(types) {
        if (types && types.length) {
            Utils.insetContent(this.popupHeader, tmplNavigation({types}));
        }
    }

    _bindEventHeaderNavigation() {
        const typesButtons = Array.from(this.popupHeader.querySelectorAll('.j-popup-map__type'));
        const activeButton = typesButtons.find((type) => {
            return type.classList.contains(this.activeClass);
        });

        if (activeButton) {
            this._selectType(activeButton.dataset.type);
        }

        typesButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                typesButtons.forEach((typeInner) => {
                    typeInner.classList.remove(this.activeClass);

                    if (typeInner === button) {
                        typeInner.classList.add(this.activeClass);
                    }
                });

                this._selectType(button.dataset.type);
            });
        });
    }

    _selectType(type) {
        this.map.hideAllMarkers();
        this.map.addFilterItem([type]);
        this.map.updateGroups(type);
    }
}

export default YandexMapPopup;
